import React from 'react'
import { CircularProgress, Typography } from '@material-ui/core'
import { ArrowDownward } from '@material-ui/icons'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useChat } from 'hooks/useChat'
import { useChatAnchorScroll } from 'hooks/useChatAnchorScroll'
import { ChatMessages } from 'components/data/ChatMessages/ChatMessages'
import { ChatComposer } from 'components/forms/ChatComposer/ChatComposer'
import * as Styled from './ChatScreen.styles'

const ChatScreen: React.FC = () => {
  const { chatId } = useParams<{ chatId?: string }>()
  const { t } = useTranslation()
  const {
    messages,
    isSending,
    isHistoryLoading,
    isHistoryError,
    anchorMessageId,
    loadedChatId,
    handleSend,
  } = useChat(chatId)
  const {
    scrollRef,
    lastTurnRef,
    gutterRef,
    showScrollToBottom,
    scrollToBottom,
  } = useChatAnchorScroll({ chatId, loadedChatId, anchorMessageId, messages })
  const hasMessages = messages.length > 0

  return (
    <Styled.ScreenContainer $fullHeight>
      <Styled.Main>
        {isHistoryLoading && <CircularProgress color='primary' />}
        {isHistoryError && (
          <Typography color='error'>{t('common.errors.generic')}</Typography>
        )}
        {hasMessages && (
          <Styled.Body>
            <ChatMessages
              messages={messages}
              scrollRef={scrollRef}
              lastTurnRef={lastTurnRef}
              gutterRef={gutterRef}
            />
            {showScrollToBottom && (
              <Styled.ScrollToBottomButton
                aria-label={t('aiChat.scrollToBottom')}
                onClick={scrollToBottom}
              >
                <ArrowDownward fontSize='small' />
              </Styled.ScrollToBottomButton>
            )}
          </Styled.Body>
        )}
        <Styled.ComposerWrapper $hasMessages={hasMessages}>
          <ChatComposer isSending={isSending} hasMessages={hasMessages} onSend={handleSend} />
        </Styled.ComposerWrapper>
      </Styled.Main>
    </Styled.ScreenContainer>
  )
}

export { ChatScreen }
